<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Editar Documento</h1>
          <b-row>
            <b-col sm="12" md="5">
              <b-form-group label="Título: *">
                <b-input-group class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="Título" autocomplete="titulo"
                    v-model="form.titulo" :state="chkState('titulo')" autofocus />
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="7">
              <b-form-group label="Cor do bloco de apresentação: *"
                invalid-feedback='É obrigatório informar a cor do bloco de apresentação.'>
                <b-form-select v-model.trim="form.cor" :state="chkState('cor')" placeholder="" class="mb-3"
                  :options='options_cor_bloco'>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Arquivo: *" for="arquivo">
                <b-form-file id="arquivo" ref="arquivo" v-on:change="uploadFile" :state="chkState('arquivo')"
                  placeholder="Escolha um arquivo..." browse-text="Selecionar" />
                <span v-if="mostra_arquivo"><a :href="form.arquivo" target="_blank">Documento</a></span>
                <b-form-invalid-feedback id="input1LiveFeedback9">Arquivo é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group label="Situação: *" for="status">
                  <b-form-radio-group ref="status" v-model="form.status" :options="status" required />
                </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Url:">
                <b-form-input type="text" class="form-control" placeholder="Url" v-model="form.url"
                  :disabled="disable_buttons" autofocus />
                <span v-if="mostra_url"><a style="color: #17a2b8; cursor: pointer;" @click="abrirDocumento(form.url)">Url</a></span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="4">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Editar</span>
            </b-button>
          </b-col>
          <b-col v-else md="4">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/arquivos')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const regexUrl = new RegExp(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i);


export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      cor: {
        required
      },
      arquivo: {
        required
      },
      status: {
        required
      }
    }
  },
  created() {
    this.loadArquivo(this.$route.params.id)
  },
  data() {
    return {
      loading: false,
      form: {
        titulo: '',
        cor: null,
        arquivo: null,
        status: true,
        url: ''
      },
      mostra_arquivo: false,
      mostra_url: false,
      id_conferencia: SessionStorage.get('conferencia_atual_id'),
      disable_buttons: false,
      salvarForm: false,
      options_cor_bloco: [
        { 'value': null, 'text': 'Selecione' },
        { 'value': 'azul', 'text': 'Azul' },
        { 'value': 'verde', 'text': 'Verde' },
        { 'value': 'amarelo', 'text': 'Amarelo' },
        { 'value': 'roxo', 'text': 'Roxo' },
        { 'value': 'vermelho', 'text': 'Vermelho' }
      ],
      status: [
        { value: true, text: 'Ativo' },
        { value: false, text: 'Inativo' }
      ],
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isValidSelection() {
      return this.selected !== '' && this.selected !== 'forbidden value'
    },
  },
  mounted() {
    // 
  },
  watch: {
    //
  },
  methods: {
    salvar() {
      var arquivo = null

      if (this.form.arquivo.includes('base64')) {
        arquivo = this.form.arquivo
      }

      let data = {
        titulo: this.form.titulo,
        cor_bloco: this.form.cor,
        arquivo: arquivo,
        status: this.form.status,
        url: this.form.url
      }
      this.loading = true

      Vue.http.put('api/arquivos/' + this.$route.params.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({ path: '/arquivos' })
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    loadArquivo(id) {
      Vue.http.get('api/arquivos/' + id).then(response => {

        let data = response.body.data[0]

        this.form.titulo = data.titulo
        this.form.status = data.status > 0 ? true : false
        this.form.cor = data.cor_bloco

        if (data.arquivo !== null) {
          this.mostra_arquivo = true
        }

        this.form.arquivo = data.arquivo

        if (data.url !== null) {
          this.mostra_url = true
        }
        this.form.url = data.url
      })
    },
    uploadFile(evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      var indexBusca = arquivo[0].type.indexOf('video');

      if (indexBusca != -1) {
        this.$refs['arquivo'].reset()
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Arquivo inválido!', 'Erro!', 7000)
        return false
      }

      if (arquivo[0].size > 15000000) {
        this.$refs['arquivo'].reset()
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Tamanho máximo permitido para o arquivo é 15Mb.', 'Alerta', 5000)
        return false
      }

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.form.arquivo = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
      this.mostra_arquivo = false
    },
    isBase64(str) {
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
    confirmar() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit() {
      if (this.form.url !== '' && this.form.url !== null) {
        if (!regexUrl.test(this.form.url)) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Url inválida!', 'Alerta', 5000)
          return false
        }
      }

      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState(val) {
      const field = this.$v.form[val]
      if (!field && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    abrirDocumento(documento) {
      if (documento.indexOf("http://") !== -1 || documento.indexOf("https://") !== -1) {
        window.open(documento, '_blank')
      } else {
        window.open('https://' + documento, '_blank')
      }
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/arquivos/ArquivosEditar.vue